import { selectGlobalSettings, useSelector } from '@oneview/redux';
import { selectBaseCurrency } from '@oneview/redux/misc/miscSelectors';
import { isMidasQuoteSource } from '@/utils';

export function useCurrentBaseCurrency() {
    const { defaultBaseCurrency } = useSelector(selectGlobalSettings);
    const baseCurrency = useSelector(selectBaseCurrency);

    return isMidasQuoteSource() ? baseCurrency || defaultBaseCurrency : undefined;
}
